import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 -192 469.333 469",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -192 469.333 469\" id=\"minus\"><path d=\"M437.332.168H32c-17.664 0-32 14.336-32 32V53.5c0 17.664 14.336 32 32 32h405.332c17.664 0 32-14.336 32-32V32.168c0-17.664-14.336-32-32-32zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol